import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { vservice } from '@niknevis/vue-modules'
import { AdminUserService } from '@/modules/user/services/admin-user.service'
import { WalletUpdateRequestModel } from '@/modules/wallet/models/wallet-request.model'

@vservice()
export class UserWalletUpdateUseCase implements BaseRequestLoadingHandler {
  isLoading = false
  isSuccess = false

  constructor(
    private readonly service: AdminUserService
  ) {
  }

  execute(userId: number, data: WalletUpdateRequestModel) {
    return this.service.walletUpdate(userId, data)
      .onStart(progress => {
        this.isLoading = true
        this.isSuccess = false
      })
      .onFinish(() => {
        this.isLoading = false
      })
      .onSuccess(() => {
        this.isSuccess = true
      })
  }
}